import { MediaObject } from 'types'
import validators from './base'
import { ScheduledPostSettings, YoutubePostSettings } from 'api/clients/ScheduledPostsClient'

const youtubeContentValidator = (content: string): string[] => {
  const rules = {
    maxCharacters: 5000,
  }
  return validators.validateTextLength(content, rules.maxCharacters, false)
}

const youtubeFileValidator = (files: MediaObject[]): string[] => {
  return validators.validateFileCount(files, 1, 1)
}

const youtubeVideosSizeValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxSize: 4 * 1024 * 1024 * 1024, // 4GB
  }
  return validators.validateVideosSize(files, rules.maxSize, 'GB')
}

const youtubeImageSizeValidator = (files: MediaObject[]): string[] => {
  return []
}

const youtubeDurationValidator = (files: MediaObject[]): string[] => {
  const minDuration = 5
  const maxDuration = 180 // 3 minutes
  return validators.validateVideosDuration(files, minDuration, maxDuration, 'seconds')
}

const youtubeFormatValidator = (files: MediaObject[]): string[] => {
  const formats = ['video/mp4', 'video/quicktime', 'video/webm']
  return validators.validateVideosFormat(files, formats, 'YouTube')
}

const youtubeVideosCountValidator = (files: MediaObject[]): string[] => {
  return validators.validateVideosCount(files, 1, 1)
}

const youtubeAspectRatioValidator = (files: MediaObject[]): string[] => {
  // No aspect ratio restriction for now
  return []
}

export const isYoutubeSettings = (settings?: ScheduledPostSettings | null): settings is YoutubePostSettings => {
  return settings !== undefined && settings !== null && typeof settings === 'object'
}

const youtubePostSettingsValidator = (settings?: ScheduledPostSettings): string[] => {
  const errors: string[] = []

  // First check if settings exist and are valid
  if (!isYoutubeSettings(settings)) {
    errors.push('Please provide valid YouTube post settings.')
    return errors
  }

  // 1. Title validation - check both post_settings.title and video.source_title
  if (!settings.title && !(settings as any).video?.source_title) {
    errors.push('Please provide a title for your video.')
  }

  // 2. Privacy level validation
  if (!settings.privacy_level) {
    errors.push('Please indicate the privacy level of your post.')
  }

  // 3. Description validation - check both content and description
  if (!settings.description) {
    errors.push('Please provide a description for your video.')
  }

  return errors
}

const youtubeValidators = {
  validateContent: youtubeContentValidator,
  validateFiles: youtubeFileValidator,
  validateVideosSize: youtubeVideosSizeValidator,
  validateImagesSize: youtubeImageSizeValidator,
  validateVideosDuration: youtubeDurationValidator,
  validateVideosAspectRatio: youtubeAspectRatioValidator,
  validateVideosFormat: youtubeFormatValidator,
  validateVideosCount: youtubeVideosCountValidator,
  validatePostSettings: youtubePostSettingsValidator,
}

export default youtubeValidators
